/**
 * Network Status Store (GRO-32)
 * Tracks online/offline state for the app
 */
import { create } from 'zustand';

const useNetworkStore = create((set, get) => ({
  // Network state
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  wasOffline: false, // Track if we were offline (for showing "back online" message)

  // Actions
  setOnline: () => {
    const { isOnline } = get();
    if (!isOnline) {
      // We were offline, now online
      set({ isOnline: true, wasOffline: true });
      // Clear the "was offline" flag after showing message
      setTimeout(() => set({ wasOffline: false }), 3000);
    }
  },

  setOffline: () => set({ isOnline: false }),

  // Initialize listeners (call once on app mount)
  initNetworkListeners: () => {
    if (typeof window === 'undefined') return;

    const handleOnline = () => get().setOnline();
    const handleOffline = () => get().setOffline();

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Return cleanup function
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }
}));

export default useNetworkStore;
